import { classNames } from "@/data/classnames";

interface AliasDisplayProps {
  value: string;
  valueToAliases: Record<string, string[]>;
  active?: boolean;
  className?: string;
}

/**
 * Displays alias hints for a dropdown option
 * Shows aliases in parentheses next to the option label
 */
export function AliasDisplay({ 
  value, 
  valueToAliases, 
  active, 
  className 
}: AliasDisplayProps) {
  if (!valueToAliases[value] || valueToAliases[value].length === 0) {
    return null;
  }
  
  return (
    <span className={classNames(
      "text-xs ml-2",
      active ? "text-white opacity-70" : "text-gray-500",
      className
    )}>
      ({valueToAliases[value].join(", ")})
    </span>
  );
}